"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.columnsWithWidths = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactTable = _interopRequireWildcard(require("react-table"));

var _semanticUiReact = require("semantic-ui-react");

var _lodash = require("lodash");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NoDataComponent = _interopRequireDefault(require("./NoDataComponent"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getColumnFromLocalStorage = function getColumnFromLocalStorage(title, id) {
  var erisx_user = localStorage.getItem('erisx_user');
  return (0, _lodash.get)(JSON.parse(localStorage.getItem('XTable')), [erisx_user, title, id]);
}; // recurse through, spread in widths where applicable


var columnsWithWidths = function columnsWithWidths(metadata, title) {
  return metadata.map(function (column) {
    if (!column.columns) {
      return _objectSpread(_objectSpread({}, column), {}, {
        width: getColumnFromLocalStorage(title, column.id || column.accessor) || column.width
      });
    }

    return _objectSpread(_objectSpread({}, column), {}, {
      columns: columnsWithWidths(column.columns, title)
    });
  });
}; // passed into TableComponent to render small list view
// TODO: pass props to TableItem, i.e. icon, header, description


exports.columnsWithWidths = columnsWithWidths;

var TableItem = function TableItem(_ref) {
  var row = _ref.row;
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List.Item, null, (0, _lodash.get)((0, _lodash.find)(row, {
    key: '8-icon'
  }), 'props.children'), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List.Content, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List.Header, null, (0, _lodash.find)(row, {
    key: '0-time'
  })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List.Description, null, (0, _lodash.find)(row, {
    key: '2-type'
  }), (0, _lodash.find)(row, {
    key: '3-quantity'
  }), (0, _lodash.find)(row, {
    key: '1-product'
  }))));
}; // need these every time we show a small view


var TdComponent = function TdComponent(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement("span", null, children);
};

var TrComponent = function TrComponent(_ref3) {
  var icon = _ref3.icon,
      title = _ref3.title,
      description = _ref3.description,
      children = _ref3.children;
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List, null, /*#__PURE__*/_react["default"].createElement(TableItem, {
    icon: icon,
    header: title,
    description: description,
    row: children
  }));
};

var Table = function Table(props) {
  // split className into array to find "dark" and spread into default props
  var classes = (0, _lodash.get)(props, 'className', '').split(' ');
  var smallProps = {
    TdComponent: TdComponent,
    TrComponent: TrComponent,
    TheadComponent: function TheadComponent() {
      return null;
    },
    // hide Thead, disable forced min-width for Tbody
    TbodyComponent: function TbodyComponent(_ref4) {
      var children = _ref4.children;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "rt-tbody"
      }, children);
    }
  };

  if (!props.title) {
    console.warn('XTable does not have a unique title prop. Naming collisions will occur in localStorage!');
  }

  if (!localStorage.getItem('erisx_user')) {
    console.warn('No erisx_user stored! Column settings will be written globally.');
  }

  Object.assign(_reactTable.ReactTableDefaults, {
    // should be global
    NoDataComponent: _NoDataComponent["default"],
    LoadingComponent: function LoadingComponent(_ref5) {
      var loading = _ref5.loading;
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Dimmer, {
        active: loading,
        inverted: classes.indexOf('dark') === -1
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Loader, null));
    }
  });
  return /*#__PURE__*/_react["default"].createElement(_reactTable["default"], (0, _extends2["default"])({}, props, {
    columns: columnsWithWidths(props.columns, props.title)
  }, props.small && smallProps || [], {
    // handle column resizing
    onResizedChange: function onResizedChange(newResized) {
      // Use last element in newResized. Last edited column is pushed to end, not beginning.
      var _last = (0, _lodash.last)(newResized),
          id = _last.id,
          value = _last.value; // localStorage requires strings for key:value pairs


      var tables = JSON.parse(localStorage.getItem('XTable') || '{}');
      var erisx_user = localStorage.getItem('erisx_user');
      (0, _lodash.set)(tables, [erisx_user, props.title, id], value);
      localStorage.setItem('XTable', JSON.stringify(tables));
    },
    className: // merge default classes with prop, cull dupes and extra spaces
    (0, _lodash.uniq)(['-highlight', props.small ? ' small' : undefined].concat((0, _toConsumableArray2["default"])(classes))).join(' ').replace(/\s+/g, ' ') // remove extra internal spaces
    .trim()
  }));
};

Table.propTypes = {
  title: _propTypes["default"].string.isRequired,
  columns: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    Header: _propTypes["default"].string,
    columns: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      Header: _propTypes["default"].string,
      accessor: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].string]),
      id: _propTypes["default"].string.isRequired,
      // need to provide an ID; accessor can be non-unique
      width: _propTypes["default"].number
    }))
  })).isRequired
};
var _default = Table;
exports["default"] = _default;